import types, { ActionCreators } from './types';

const constraintComponentERR: ActionCreators['ConstraintComponentERR'] = (
  constraintType,
  errorMessages,
  error,
) => ({
  type: types.CONSTRAINT_COMPONENT_ERR,
  constraintType,
  errorMessages,
  error,
});

const constraintComponentOK: ActionCreators['ConstraintComponentOK'] = (constraintType, id) => ({
  type: types.CONSTRAINT_COMPONENT_OK,
  constraintType,
  id,
});

const constraintComponentsERR: ActionCreators['ConstraintComponentsERR'] = (
  errorMessages,
  error,
) => ({
  type: types.CONSTRAINT_COMPONENTS_ERR,
  errorMessages,
  error,
});

const constraintComponentsOK: ActionCreators['ConstraintComponentsOK'] = () => ({
  type: types.CONSTRAINT_COMPONENTS_OK,
});

const constraintToggleUpdate: ActionCreators['ConstraintToggleUpdate'] = (
  constraintConfigurationKey,
) => ({
  type: types.CONSTRAINT_TOGGLE_UPDATE,
  constraintConfigurationKey,
});

const constraintConfigurationUpdate: ActionCreators['ConstraintConfigurationUpdate'] = (
  constraintConfigurationKey,
  key,
  value,
) => ({
  type: types.CONSTRAINT_CONFIGURATION_UPDATE,
  constraintConfigurationKey,
  key,
  value,
});

const requestConstraint: ActionCreators['RequestConstraint'] = (id, constraintType) => ({
  type: types.REQUEST_CONSTRAINT,
  id,
  constraintType,
});

const requestConstraintERR: ActionCreators['RequestConstraintERR'] = (errorMessages, error) => ({
  type: types.REQUEST_CONSTRAINT_ERR,
  errorMessages,
  error,
});

const requestConstraintOK: ActionCreators['RequestConstraintOK'] = (selectedConstraint) => ({
  type: types.REQUEST_CONSTRAINT_OK,
  selectedConstraint,
});

const requestConstraintsOK: ActionCreators['RequestConstraintsOK'] = () => ({
  type: types.REQUEST_CONSTRAINTS_OK,
});

const resetInitialConstraintsState: ActionCreators['ResetInitialConstraintsState'] = (
  constraints,
) => ({
  type: types.RESET_INITIAL_CONSTRAINTS_STATE,
  constraints,
});

const actions = {
  constraintComponentERR,
  constraintComponentOK,
  constraintComponentsERR,
  constraintComponentsOK,
  constraintToggleUpdate,
  constraintConfigurationUpdate,
  requestConstraint,
  requestConstraintERR,
  requestConstraintOK,
  requestConstraintsOK,
  resetInitialConstraintsState,
};
export default actions;
